/**
 * checkout.js
 */
$(function () {
    $('.gadget').on('click', function() {
        window.location = $(this).find('a').attr('href');
    });
});